import { render, staticRenderFns } from "./page-map-test.vue?vue&type=template&id=27adb76d"
import script from "./page-map-test.vue?vue&type=script&lang=ts"
export * from "./page-map-test.vue?vue&type=script&lang=ts"
import style0 from "./page-map-test.vue?vue&type=style&index=0&id=27adb76d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports